<template>
<div>
     <v-dialog
      width="100%"
      v-model="dialog"
    >
      <template v-slot:activator="{ on, attrs }">
          <img src="../assets/button-rule.png" alt="" class="rule"  v-bind="attrs"
          v-on="on">
      </template>
        <div class="rule-container">
             <img src="../assets/modal/close.png" alt="" class="close" @click="dialog=false">
            <div class="wrapper">
                <p>欢迎各位小狼人参与狼堡许愿活动哦~</p>
                <p>1.许愿时间12.25-12.30，登录即可获得1次许愿机会</p>
                <p>2.许愿成功后，前往论坛分享许愿截图参与盖楼活动，点击前往</p>
                <p>3.活动结束后，狼妹将在许愿的狼友中随机抽取幸运狼友100名，实现你们的愿望！愿望奖励将在活动结束的15个工作日内通过游戏内邮件发放，请注意查收！</p>
                <p>4.中奖名单届时将在“狼人之间”官方微信号中公布，祝各位小狼人都能许愿成功哦！</p>
                <p>5.关注“狼人之间”官方微信公众号，回复关键词“愿望实现卡”获取抽奖入口，抽取实现愿望额外名额，只要中奖，狼妹必将帮你实现在许愿树中许下的愿望！</p>
            </div>
        </div>
    </v-dialog>
</div>
</template>

<script>
export default {
    name: 'ruleButton',
    data() {
        return {
             dialog: false,
        }
    }
}
</script>

<style lang="scss" scoped>
.rule {
    position: absolute;
    right: 0;
    top: 106vw;
    width: 8.15vw;
}
.close {
    width: 15.1vw;
    position: absolute;
    right: 4vw;
    z-index: 100;
}
.rule-container {
    overflow: hidden;
}
.wrapper {
    width: 85.74vw;
    margin: 0 auto;
    margin-top: 15vw;
    min-height: 69.44vw;
    background-image: url("../assets/modal/rule.png");
    background-size: 100% 100%;
    overflow: hidden;
    font-size: 12px;
    padding: 10vw 4vw 0;
    color: #609173;
    p {
        margin: 6px 0;
    }
}
</style>